import type { ReactElement, Ref } from 'react'

/** Reads a ref from a React element, where React 19 exposes it as `props.ref`. */
export function getReactElementRef<T>(element: ReactElement): Ref<T> | undefined {
  return (element.props as { ref?: Ref<T> }).ref
}
